module.exports = __webpack_public_path__ + "img/mobile-plus-icon.485c48ea.svg";